
const patient = [
  {
    title: 'Dashboard',
    path: '/patient',
    icon: 'fluent-color:home-16',
  },
  {
    title: 'Services',
    path: '/patient/Services',
    icon: 'fluent-color:molecule-48',
  },
  {
    title: "Profiles",
    path: "/patient/members",
    icon: "fluent-color:people-community-16",
  },
  {
    title: "Raise Query",
    path: "/patient/patient_query",
    icon: "flat-color-icons:assistant",
  },
];

const superadmin = [
  {
    title: 'Dashboard',
    path: '/superadmin',
    icon: 'fluent-color:home-16',
  },
    {
    title: "Log Maintenance",
    path: "/superadmin/LogMaintenance",
    icon: "material-icon-theme:folder-log",
  },
  {
    title: 'Roles',
    path: '/superadmin/roles',
    icon: 'flat-color-icons:rating',
  },
  {
    title: 'Doctors',
    path: '/superadmin/doctors',
    icon: 'flat-color-icons:reading-ebook',
  },
  {
    title: 'Patients',
    path: '/superadmin/patients',
    icon: 'flat-color-icons:conference-call',
  },
  {
    title: "Services",
    path: "/superadmin/services",
    icon: "fluent-color:molecule-48",
  },
  {
    title: "Carousels",
    path: "/superadmin/carousels",
    icon: "flat-color-icons:edit-image",
  },
  {
    title: "FAQs",
    path: "/superadmin/faqs",
    icon: "flat-color-icons:assistant",
  },
  {
    title: "Testimonials",
    path: "/superadmin/testimonials",
    icon: "flat-color-icons:voice-presentation",
  },
  {
    title: "Partners",
    path: "/superadmin/partners",
    icon: "flat-color-icons:donate",
  },
   {
  title: "Reports",
  path: "/superAdmin/adminReport", 
  icon: "flat-color-icons:bar-chart"
}


];

const admin =  [
  {
    title: "Dashboard",
    path: "/admin",
    icon: "fluent-color:apps-16",
  },
  {
    title: 'Doctors',
    path: '/admin/doctors',
    icon: 'flat-color-icons:reading-ebook',
  },
  {
    title: "Services",
    path: "/admin/services",
    icon: "fluent-color:molecule-48",
  },
  {
    title: "Carousels",
    path: "/admin/carousels",
    icon: "flat-color-icons:edit-image",
  },
  {
    title: "FAQs",
    path: "/admin/faqs",
    icon: "flat-color-icons:assistant",
  },
  {
    title: "Testimonials",
    path: "/admin/testimonials",
    icon: "flat-color-icons:voice-presentation",
  },
  {
    title: "Partners",
    path: "/admin/partners",
    icon: "flat-color-icons:donate",
  },
  {
    title: "Respond to customer service",
    path: "/admin",
    icon: "uim:user-md",
  },
  {
    title: "Reports",
    path: "/admin/adminReport",
    icon: "flat-color-icons:bar-chart"
  },
];

const doctor =  [
  {
    title: "Dashboard",
    path: "/doctor",
    icon: "fluent-color:home-16",
  },
  {
    title: "Profile",
    path: "/doctor/profile",
    icon: "flat-color-icons:reading-ebook",
  },
  {
    title: "Availability",
    path: "/doctor/availability",
    icon: "flat-color-icons:clock",
  },
  {
    title: "Calendar",
    path: "/doctor/calendar",
    icon: "flat-color-icons:calendar",
  },
  {
    title: "Reports",
    path: "/doctor/report/id",
    icon: "flat-color-icons:bar-chart"
  },
  // {
  //   title: "AHPRA",
  //   path: "/doctor/AHPRA",
  //   icon: "flat-color-icons:diploma-2",
  // },
  {
    title: "Raise Query",
    path: "/doctor/raise-query",
    icon: "flat-color-icons:assistant",
  },
];


export const navData = {
  doctor,
  patient,
  admin,
  superadmin
};
